import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/** A page view on every route change, by the route's pattern alone. The app and the site both mount it. */
export default function Pageviews() {
    const { pathname } = useLocation();
    useEffect(() => {
        trackPageview(pathname, window.location.origin);
    }, [pathname]);
    return null;
}
